import { useLingui } from '@lingui/react/macro';
import { LanguageSquare } from 'iconsax-reactjs';
import type { FC } from 'react';
import { Select, type SelectProps } from '@/shared/Select';
import { config as languages } from '../i18n/locales';
import { type Settings, useSettings } from './api';

export const LanguageSelect: FC<
  Omit<
    SelectProps<false, Settings['language']>,
    'value' | 'onChange' | 'options'
  > & {
    mini?: boolean;
  }
> = ({ mini, ...props }) => {
  const { i18n } = useLingui();
  const [settings, setSettings] = useSettings();

  return (
    <Select
      value={settings.language}
      onChange={(newLocale) =>
        setSettings({ language: (newLocale as Settings['language']) ?? 'en' })
      }
      options={Object.keys(languages).map((locale) => ({
        key: locale,
        value: locale,
        label: (target) =>
          target === 'option' ? (
            <div className="text-center">
              {languages[locale as Settings['language']].name}
            </div>
          ) : (
            <>
              <LanguageSquare size={18} className="me-1" />
              {
                languages[i18n.locale as Settings['language']][
                  mini ? 'code' : 'name'
                ]
              }
            </>
          ),
      }))}
      {...props}
    />
  );
};
